import { Component, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { CalendarEvent } from 'angular-calendar';
import { setHours, setMinutes } from 'date-fns';

@Component({
  selector: 'mwl-demo-component',
  templateUrl: './meeting-calendar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./meeting-calendar.component.scss']
})
export class MeetingCalendarComponent implements OnInit {
  ngOnInit(): void {
    throw new Error("Method not implemented.");
  }
 
 view: string = 'day';

  viewDate: Date = new Date();

  events: CalendarEvent[] = [
    {
      title: 'No event end date',
      start: setHours(setMinutes(new Date(), 0), 3),
    
    },
    {
      title: 'No event end date',
      start: setHours(setMinutes(new Date(), 0), 5),
    }
  ];
}



// WEBPACK FOOTER //
// ./src/app/shared/components/meeting-calendar/meeting-calendar.component.ts